// extracted by mini-css-extract-plugin
export default {"link":"RegisterList_link__ojhKd"};